import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import LogsWithContext from '../../components/Logs/LogsWithContext';
import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { LogsBlockPage } from '../../components/Logs/LogsBlockPage';

export const LogsRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.LOGS.ID);
    const disabled = !useHasPermissions({ permission: Pages.LOGS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={LogsWithContext}
            disabled={disabled}
            displayBlockPage={displayBlockPage}
            blockPageComponent={LogsBlockPage}
        />
    );
};
